export default "__VITE_ASSET__DwknjUgR__"